import styles from "./DesignBoxTabEditRow.module.css";
import DesignBoxTabEditSingle from "./DesignBoxTabEditSingle";
const DesignBoxTabEditRow = ({ items, activeTabNumber }) => {
  return (
    <div className={styles.row_main_div}>
      {Array.isArray(items) &&
        items.length > 0 &&
        items.map((item, index) => {
          return (
            <DesignBoxTabEditSingle
              key={index}
              item={item}
              activeTabNumber={activeTabNumber}
            />
          );
        })}
    </div>
  );
};
export default DesignBoxTabEditRow;
